<template>
  <div class="members-of-pmgc" id="pmgcMembers">
    <navbar/>
    <div class="allMemberSlides">
       <div class="slider" id="sliderMembers">
        <ul class="slides ">
          <li>
            <img src="../../assets/members/president22.jpg" alt="PMGC President Mr. Agboola"> <!-- random image -->
            <div class="caption left-align">
              <h4>The President</h4>
              <h5 class="light grey-text text-lighten-3">Mr. Abdulkadri G. Agboola</h5>
            </div>
          </li>
          <li>
            <img src="../../assets/members/makinde.jpg" alt="PMGC Member. Dr. Makinde"> <!-- random image -->
            <div class="caption right-align">
              <h4>Head of Educational Services and consultancy</h4>
              <h5 class="light grey-text text-lighten-3">Dr. Mrs. Deborah O. Makinde</h5>
            </div>
          </li>
          <li>
            <img src="../../assets/members/jaiyeola.jpg" alt="PMGC Member, Dr. Jaiyeola"> <!-- random image -->
            <div class="caption left-align">
              <h4>Head of Human Resources Management</h4>
              <h5 class="light grey-text text-lighten-3">Dr. Temitope G. Jaiyeola</h5>
            </div>
          </li>
          <li>
            <img src="../../assets/members/femiUk.jpg" alt="Omotosho Femi UK, PMGC Member">
            <div class="caption right-align">
              <h4>International Legal Unit</h4>
              <h5 class="light grey-text text-lighten-3">Mr. Femi Omotosho (UK)</h5>
            </div>
          </li>
          <li>
            <img src="../../assets/members/fin sec.jpg"> <!-- random image -->
            <div class="caption right-align">
              <h4>Data Analyst</h4>
              <h5 class="light grey-text text-lighten-3">Mr. Oluwatosin Olaniyan</h5>
            </div>
          </li>
          <li>
            <img src="../../assets/members/ajibson.jpg"/> <!-- random image -->
            <div class="caption left-align">
              <h4>Acting Project Manager</h4>
              <h5 class="light grey-text text-lighten-3">Mr. Samson T. Ajibola</h5>
            </div>
          </li>
          <li>
            <img src="../../assets/members/ezekiel.jpg"> <!-- random image -->
            <div class="caption left-align">
              <h4>Cyber Security Official</h4>
              <h5 class="light grey-text text-lighten-3">Mr. Ezekiel Aliyu</h5>
            </div>
          </li>
          <li>
            <img src="../../assets/members/crandell.jpg"> <!-- random image -->
            <div class="caption left-align">
              <h4>Member</h4>
              <h5 class="light grey-text text-lighten-3">Mr. IAN Crandell</h5>
            </div>
          </li>
          <li>
            <img src="../../assets/members/mr.Kenny.png"> <!-- random image -->
            <div class="caption right-align">
              <h4>Chief Finance Officer</h4>
              <h5 class="light grey-text text-lighten-3">Mr. Kehinde Adeshina</h5>
            </div>
          </li>

          <!-- <li>
            <img src="../../assets/members/taiwoimg.png">
            <div class="caption left-align">
              <h4>Member</h4>
              <h5 class="light grey-text text-lighten-3">Mr. Taiwo Adeshina</h5>
            </div>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="members">
        <h3 class="text-center center-align" id="teamMembers"><i class="icon ion-android-contacts"></i> &nbsp;PMGC Members</h3>
        <div class="col s10 m6 l3 offset-s1">
          <div class="card">
            <div class="card-image">
              <img src="../../assets/members/makinde.jpg" class="responsive-img" style="height: 307px">
              <span class="card-title">Dr. Mrs. Deobrah Makinde O.</span>
            </div>
            <div class="card-content">
              <span class="black-text bold">Head of Educational Services and Consultancy</span>
              <p>She is a complex analyst and educationist who has taught at all levels of education and ...</p>
            </div>
            <div class="card-action blue grey-text center-align text-center">
              <a class="btn waves-effect waves-ripple grey darken-2">More...</a>
            </div>
          </div>
        </div>
        <div class="col s10 m6 l3 offset-s1">
          <div class="card">
            <div class="card-image">
              <img src="../../assets/members/jaiyeola.jpg" class="responsive-img" style="height: 307px">
              <span class="card-title">Dr. Jaiyeola Temitope G.</span>
            </div>
            <div class="card-content">
              <span class="black-text bold">Head of Human Resources Management</span>
              <p>Senior lecturer in the Department of Mathematics, Obafemi Awolowo University Ile-Ife... </p>
            </div>
            <div class="card-action blue grey-text center-align text-center">
              <a class="btn waves-effect grey darken-2 waves-ripple">More...</a>
            </div>
          </div>
        </div>
        <div class="col s10 m6 l3 offset-s1">
          <div class="card">
            <div class="card-image">
              <img src="../../assets/members/president22.jpg" class="responsive-img" style="height: 307px">
              <span class="card-title">Mr. Abdulkadri Agboola G.</span>
            </div>
            <div class="card-content">
              <span class="black-text bold">President</span><br><br>
              <p>He participated in National Mathematics Competition for Polytechnic Students (NAMCPS) in 2012... </p>
            </div>
            <div class="card-action blue grey-text center-align text-center">
              <a class="btn waves-effect grey darken-2 waves-ripple">More...</a>
            </div>
          </div>
        </div>
        <div class="col s10 m6 l3 offset-s1">
          <div class="card">
            <div class="card-image">
              <img src="../../assets/members/fin sec.jpg" class="responsive-img" style="height: 307px">
              <span class="card-title">Mr. Olaniyan Oluwatosin</span>
            </div>
            <div class="card-content">
              <span class="black-text bold">Data Analyst</span><br><br>
              <p>He is a Data Analyst.<br/>he has National Diploma (ND) in Statistics from Departmen... </p>
            </div>
            <div class="card-action blue grey-text center-align text-center">
              <a class="btn waves-effect grey darken-2 waves-ripple">More...</a>
            </div>
          </div>
        </div>
        <div class="col s10 m6 l3 offset-s1">
          <div class="card">
            <div class="card-image">
              <img src="../../assets/members/ajibson.jpg" class="responsive-img" style="height: 307px">
              <span class="card-title">Mr. Ajibola Samson T.</span>
            </div>
            <div class="card-content">
              <span class="black-text bold">Acting Project Manager</span><br><br>
              <p>Ajibola Samson Tobi had B.sc Mathematics<br/>graduated from ... </p>
            </div>
            <div class="card-action blue grey-text center-align text-center">
              <a class="btn waves-effect grey darken-2 waves-ripple">More...</a>
            </div>
          </div>
        </div>
        <div class="col s10 m6 l3 offset-s1">
          <div class="card">
            <div class="card-image">
              <img src="../../assets/members/ezekiel.jpg" class="responsive-img" style="height: 307px">
              <span class="card-title">Mr. Ezekiel Aliyu</span>
            </div>
            <div class="card-content">
              <span class="black-text bold">Cyber Security Official</span><br><br>
              <p>He is a software developer at Samoltech Studios Limited. He is currently studyin... </p>
            </div>
            <div class="card-action blue grey-text center-align text-center">
              <a class="btn waves-effect grey darken-2 waves-ripple">More...</a>
            </div>
          </div>
        </div>
        <div class="col s10 m6 l3 offset-s1">
          <div class="card">
            <div class="card-image">
              <img src="../../assets/members/crandell.jpg" class="responsive-img" style="height: 307px">
              <span class="card-title">Mr. IAN Crandell</span>
            </div>
            <div class="card-content">
              <span class="black-text bold">Advisor</span><br><br>
              <p>He had B.A. Mathematics, University of California, San Diego, 2008. He also had ... </p>
            </div>
            <div class="card-action blue grey-text center-align text-center">
              <a class="btn waves-effect grey darken-2 waves-ripple">More...</a>
            </div>
          </div>
        </div>
        <div class="col s10 m6 l3 offset-s1">
          <div class="card">
            <div class="card-image">
              <img src="../../assets/members/mr.Kenny.png" class="responsive-img" style="height: 307px">
              <span class="card-title">Mr. Kehinde Adeshina</span>
            </div>
            <div class="card-content">
              <span class="black-text bold">Chief Finance Officer</span><br><br>
              <p>He studied Physiology in the University of Ilorin, Ilorin, Nigeria, and he is a project analyst. He is also ... </p>
            </div>
            <div class="card-action blue grey-text center-align text-center">
              <a class="btn waves-effect grey darken-2 waves-ripple">More...</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-page/>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '@/components/layouts/navbar'
import FooterPage from '@/components/layouts/footer-page'
import M from 'materialize-css'
import $ from 'jquery'
export default {
  components: {Navbar, FooterPage},
  data () {
    return {}
  },
  mounted () {
    $('#pmgcMembers>div.row>div>div>div>div.card-image>img').addClass('materialboxed')
    var elem = document.querySelector('#sliderMembers')
    // eslint-disable-next-line
    var instance = new M.Slider(elem, {
      indicators: false
    })

    var el = document.querySelector('.materialboxed')
    // eslint-disable-next-line
    var instance = new M.Materialbox(el, {
      inDuration: 300,
      outDuration: 375
    })
  }
}
</script>
<style>
  div.members-of-pmgc .slider .slides li img, div.achievements #slideAchievements > ul.slides > li > img {
    height: 100%;
    width: 100%;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    filter: brightness(.7);
  }
</style>



// WEBPACK FOOTER //
// src/pmgc/members/index.vue